/** System FHIR do tier de contrato CRM (pacotes de mensagens). */
export const CRM_CONTRACT_TIER_SYSTEM =
  "https://fluxmed.com.br/crm/contract-tier";

export const CRM_CONTRACT_TIERS = {
  TRIAL: "crm20",
  STANDARD: "crm50",
  PREMIUM: "crm100",
} as const;

/** Busca agregada: trial + planos pagos. */
export const CRM_CONTRACT_IDENTIFIER_ALL = "crm20,crm50,crm100";

/** Apenas planos pagos (legado antes do trial). */
export const CRM_CONTRACT_IDENTIFIER_PAID = "crm50,crm100";

/** Chamada específica para verificação do pacote trial. */
export const CRM_CONTRACT_IDENTIFIER_TRIAL = CRM_CONTRACT_TIERS.TRIAL;
